module.exports = __webpack_public_path__ + "static/media/dep4.b23d7826.jpg";